import { render, staticRenderFns } from "./NhstResetPasswordStart.vue?vue&type=template&id=c9225fb4"
import script from "./NhstResetPasswordStart.vue?vue&type=script&lang=js"
export * from "./NhstResetPasswordStart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports